import LaboratorySearch from '../components/laboratory/LaboratorySearch';

//кнопка вверх
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 10) {
            $('#scroll').css('display', 'block');
        } else {
            $('#scroll').css('display', 'none');
        }
    });
    $('#toTop').click(function () {
        $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
        return false;
    });
});

if (document.getElementsByClassName('image-text-link').length > 0) {
    $('.image-text-link').magnificPopup({type: 'image'});
}


$('.question-item').click(function () {
    $(this).toggleClass('active');
});

if (document.getElementById('laboratory-search')) {
    new Vue({
        el: '#laboratory-search',
        components: {
            LaboratorySearch
        },
    });
}

//видео из ютуб
function findVideos() {
    let videos = document.querySelectorAll('.video');

    for (let i = 0; i < videos.length; i++) {

        setupVideo(videos[i]);
    }
}

function setupVideo(video) {
    let link = video.querySelector('.video__link');
    let media = video.querySelector('.video__media');
    let button = video.querySelector('.video__button');
    let id = parseMediaURL(media);

    video.addEventListener('click', () => {
        let iframe = createIframe(id);

        link.remove();
        button.remove();
        video.appendChild(iframe);
    });

    link.removeAttribute('href');
    video.classList.add('video--enabled');
}

function parseMediaURL(media) {
    let regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/sddefault\.jpg/i;
    let url = media.src;
    let match = url.match(regexp);

    return match[1];
}

function createIframe(id) {
    let iframe = document.createElement('iframe');

    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('src', generateURL(id));
    iframe.classList.add('video__media');

    return iframe;
}

function generateURL(id) {
    let query = '?rel=0&showinfo=0&autoplay=1';

    return 'https://www.youtube.com/embed/' + id + query;
}

findVideos();


//slick images point
$('.slick-point-images-parent').slick({
    dots: false,
    infinite: true,
    // speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',

    // centerMode: true,
    // centerPadding: '60px',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        },
    ],
});

//slick partners main
$('.slick-partners-main').slick({
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',

    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
    ],
});

//change html for mobile
if ($(window).width() < 975) {
    $("#mobile-phones").append($("#phone-messengers"));
    $("#mobile-phones").append($("#hotline"));
    $(".mobile-menu").append($("#main-menu"));
    $(".mobile-menu .main-menu").append($(".top-menu"));
    $(".mobile-language").append($(".language-block"));
}
else {
    $(".desktop-phone").append($("#hotline"));
    $(".menu-phones").append($("#phone-messengers"));
    $("#top-menu").append($(".top-menu"));
    $(".desktop-main-menu").append($("#main-menu"));
    $(".menu-language").append($(".language-block"));
}

jQuery(window).resize(function () {
    if ($(window).width() < 975) {
        $("#mobile-phones").append($("#phone-messengers"));
        $("#mobile-phones").append($("#hotline"));
        $(".mobile-menu").append($("#main-menu"));
        $(".mobile-menu .main-menu").append($(".top-menu"));
        $(".mobile-language").append($(".language-block"));
    }
    else {
        $(".desktop-phone").append($("#hotline"));
        $(".menu-phones").append($("#phone-messengers"));
        $("#top-menu").append($(".top-menu"));
        $(".desktop-main-menu").append($("#main-menu"));
        $(".menu-language").append($(".language-block"));
    }
});

window.addEventListener('scroll', function() {
    const header = document.querySelector('.header');
    if (window.scrollY > 100) {
        header.classList.add('mini-header');
    } else {
        header.classList.remove('mini-header');
    }
});

//mobile menu click
$('.mobile-menu-button').click(function () {
    $(this).toggleClass('active');
    $('.mobile-menu').toggleClass('show-menu');
    $('.header').toggleClass('full-header');
});

$('.expanded-arrow').click(function () {
    $(this).toggleClass('active');
    $(this).next('.expanded-menu').toggleClass('show-expanded-menu');
});

$('.show-analise-button').click(function () {
    $(this).toggleClass('active');
    $(this).next('.analise-list').toggleClass('d-none');
});

document.addEventListener("DOMContentLoaded", function () {

    let cityBlock = document.getElementById("filials-map");
    if (!cityBlock) return; // Прерываем выполнение, если блока нет

    document.querySelectorAll(".scroll-to-city").forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();

            let city = this.getAttribute("data-city"); // Получаем город из data-атрибута

            // Прокручиваем страницу до блока городов
            cityBlock.scrollIntoView({ behavior: "smooth", block: "end" });

            // Передаем выбранный город в Vue через событие
            window.dispatchEvent(new CustomEvent("citySelected", { detail: city }));
        });
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/common.js